export default __webpack_public_path__ + "static/media/nextOrReact.04b792c8.md";